import { ArrowClockwise } from "react-bootstrap-icons";

export const ConnectionFailed = ({ reconnect, message }) => {
    return (
        <div
            className={"m-auto d-flex display-4"}
            style={{ flexDirection: "column", alignItems: "center" }}
        >
            <div>{message || "Connection Failed"}</div>
            <button
                title="Reconnect"
                className="btn btn-lg"
                onClick={reconnect}
            >
                <ArrowClockwise
                    className={"mx-auto"}
                    style={{ fontSize: "2.2rem" }}
                />
            </button>
        </div>
    );
};
